import { useScroll, useSpring, useTransform } from "motion/react";
import { useDebounceState } from "@/hooks/tactsuit/use-debounce-state";

/*
 스크롤 시작, 종료 범위
 */
const SCROLL_START_RANGE = 0;
const SCROLL_END_RANGE = 0.9;
/*
스크롤시 이미지 변화 민감도
 */
const SCROLL_SMOOTH_RANGE = 1000; //낮을수록 부드러움 - 목표 변화 도달값
const SCROLL_STOP_RANGE = 100; //높을수록 부드러움 - 변화가 빨리 멈추는지 를 제어하는 값

interface useSmoothScrollIndexProps {
  canvasRef;
  range: number;
}
export const useSmoothScrollIndex = ({
  canvasRef,
  range,
}: useSmoothScrollIndexProps) => {
  //스크롤 진행상태 감지 ( scrollYProgress :스크롤 진행 상태)
  const { scrollYProgress } = useScroll({
    target: canvasRef, //target 영역 스크롤 감지
    offset: ["start 90%", "end 0%"], // [scroll 시작점, scroll 끝점]
  });

  // 이미지 배열 index
  const currentIndex = useTransform(
    scrollYProgress,
    [SCROLL_START_RANGE, SCROLL_END_RANGE], // default : 스크롤 범위를 90%까지만 제한

    [1, range],
  );

  const debouncedIndex = useDebounceState(currentIndex, 16);

  const smoothIndex = useSpring(debouncedIndex, {
    stiffness: SCROLL_SMOOTH_RANGE, // 낮은 stiffness로 부드럽게
    damping: SCROLL_STOP_RANGE, // 높은 damping으로 감속을 더 부드럽게
  });

  return smoothIndex;
};
